/*
 * @Author: zhangzhitao
 * @Date: 2019-03-18 16:19:14
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-10-16 14:28:43
 */

<template>
  <div class="list-nav-page">
    <div
      class="list-content"
      ref="listCt"
      v-show="!noData"
    >
      <!--返回顶部按钮-->
      <div
        class="return-up h-icon-angle_up"
        @click="returnTop"
        v-show="returnTopFlag"
      ></div>
      <el-scrollbar
        class="list-nav"
        ref="listNav"
        tag="div"
        :size="1"
        :wrap-class="wrapClass"
        @on-scrolling-y="navScroll"
      >
        <div
          class="m-main-ctn"
          v-show="!navStyle"
        >
          <div
            class="m-list-ctn"
            ref="listCtn"
          >
            <div class="menu-list">
              <div
                class="nav-title"
                :class="{
                'active': navNum === 0,
                'brand-bg-color-after': navNum === 0
                }"
              >
                {{ $t("components.widgetHomepage.nav.shortcut_title") }}
              </div>
              <div class="nav-tips">
                {{ $t("components.widgetHomepage.nav.shortcut_dec") }}
              </div>
              <div class="content cf">
                <div
                  class="content-item fl"
                  v-for="item in shortcutNav"
                  :key="item.id"
                  @click="navCardClick(item)"
                >
                  <img
                    :src="item.iconInfo.path"
                    @error="defaultPic"
                    width="64px"
                    height="64px"
                  />
                  <div
                    class="sub-nav-title"
                    :title="item.name"
                  >
                    {{ item.name }}
                  </div>
                  <div
                    class="remove h-icon-close"
                    @click.stop="removeShortcutNav(item.menuId)"
                  ></div>
                </div>
                <div
                  class="content-empty fl"
                  @click="addShortcutNav"
                >
                  <!--<span class="add-icon-plus"></span>-->
                </div>
              </div>
            </div>
            <div
              class="menu-list mt-12"
              v-for="(item, index) in totalNav"
              :key="index"
              v-show="item.isShow === 0"
            >
              <div
                class="nav-title"
                :class="{ active: navNum === index + 1,'brand-bg-color-after':navNum === index + 1 }"
              >
                {{ item.name }}
              </div>
              <div class="nav-tips">{{ item.desc }}</div>
              <div class="content cf">
                <div
                  class="content-item fl"
                  v-for="childItem in item.children"
                  :key="childItem.id"
                  v-show="childItem.isShow === 0"
                  @click="navCardClick(childItem)"
                >
                  <img
                    :src="childItem.iconInfo.path"
                    @error="defaultPic"
                    width="64px"
                    height="64px"
                  />
                  <div
                    class="sub-nav-title"
                    :title="childItem.name"
                  >
                    {{ childItem.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="m-slide-pos"
            v-if="!isConfig"
          >
            <div
              class="nav-list"
              ref="slideBox"
            >
              <div class="m-main-slide">
                <a
                  class="nav-item"
                  :class="{'active': navNum === 0,'brand-bg-color-after': navNum === 0}"
                  @click="sidebarClick(0)"
                >{{ $t("components.widgetHomepage.nav.shortcut_title") }}</a>
                <a
                  class="nav-item"
                  v-for="(item, index) in totalNav"
                  :key="item.id"
                  :class="{ active: navNum === index + 1,'brand-bg-color-after':navNum === index + 1 }"
                  @click="sidebarClick(index + 1)"
                >{{ item.name }}</a>
              </div>
            </div>
          </div>

          <!--添加快捷入口弹窗-->
          <el-dialog
            :visible.sync="shortcutDialog"
            size="small"
            customClass="no-scroll no-padding"
            :close-on-click-modal="false"
            append-to-body
          >
            <div
              slot="title"
              class="shortcut-dialog-title"
            >
              <span class="title-strong">{{
                $t("components.widgetHomepage.nav.shortcut_title")
                }}</span>
              <span class="title-light">(</span>
              <span class="title-light">{{ navCheckList.length }}</span>
              <span class="title-light">/10</span>
              <span class="title-light">{{
                $t("components.widgetHomepage.nav.add_shortcut_tips")
                }}</span>
              <span class="title-light">)</span>
            </div>
            <div class="shortcut-nav">
              <draggable
                class="shortcut-nav-list cf"
                v-model="tempShortcutNav"
              >
                <div
                  class="shortcut-nav-item fl"
                  v-for="item in tempShortcutNav"
                  :key="item.id"
                >
                  <span>{{ item.name }}</span>
                  <span
                    class="h-icon-close shortcut-nav-item-remove"
                    @click="deleteTempShortcut(item.menuId)"
                  ></span>
                </div>
              </draggable>
              <div class="shortcut-total-nav-list">
                <el-checkbox-group
                  v-model="navCheckList"
                  @change="navCheckChange"
                >
                  <div
                    class="shortcut-total-nav-item"
                    v-for="item in totalNav"
                    v-show="item.isShow===0"
                    :key="item.id"
                  >
                    <div class="total-nav-item-title">{{ item.name }}</div>
                    <el-checkbox
                      v-for="child in item.children"
                      v-show="child.isShow===0"
                      :label="child.menuId"
                      class="nav-checkbox"
                      :key="child.id"
                      :disabled="
                        checkboxDisabled &&
                          navCheckList.indexOf(child.menuId) === -1
                      "
                    >{{ child.name }}
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
            <span slot="footer">
              <el-button
                type="primary"
                @click="saveShortcutNav"
              >{{
                $t("components.widgetHomepage.nav.confirm")
                }}</el-button>
              <el-button @click="cannelShortcutNav">{{
                $t("components.widgetHomepage.nav.cancel")
                }}</el-button>
            </span>
          </el-dialog>
        </div>
        <ul
          class="m-main-ctn-card"
          id="listNavCards"
          v-show="navStyle"
        >
          <li
            class="app-box"
            v-for="(item, index) in cardNavs"
            :key="index"
            v-show="item.isShow === 0"
          >
            <div
              class="card"
              @click="navCardClick(item)"
            >
              <div class="card-outer">
                <div class="card-inner">
                  <img
                    class="app-icon"
                    @error="defaultPic"
                    :src="item.iconInfo.path"
                  />
                  <div
                    class="f-toe app-name"
                    :title="item.name"
                  >
                    {{ item.name }}
                  </div>
                  <div class="m-ellipsis app-intro">
                    <div class="box">
                      <span
                        class="cont"
                        :title="item.desc"
                      >{{
                        item.desc
                        }}</span>
                      <div
                        class="u-omit"
                        v-show="item.isOver"
                      >...</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <!-- <div class="m-switch-box">
          <el-button
            type="iconButton"
            icon="h-icon-menu_leftbar"
            v-if="navStyle === true"
            @click="navStyle = false"
          >{{ $t("components.widgetHomepage.nav.list_mode") }}</el-button>
          <el-button
            type="iconButton"
            icon="h-icon-menu"
            v-else
            @click="navStyle = true"
          >{{ $t("components.widgetHomepage.nav.card_mode") }}</el-button>
        </div> -->
      </el-scrollbar>
    </div>
    <no-data v-show="noData"></no-data>
  </div>
</template>

<script>
/*
   *  有侧边栏的导航
   * */
// 拖动事件
import draggable from 'vuedraggable'
import api from 'api/api'
import noData from './no-data'
import { mapActions } from 'vuex'
import defaultPic from '../../../assets/images/noicon.png'
import { Loading } from 'hui'
// import func from './vue-temp/vue-editor-bridge'
export default {
  name: 'list-nav',
  props: {
    refreshPeriod: {
      // 部件刷新周期
      type: Number,
      default: 0
    },
    isConfig: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  async mounted () {
    window.onresize = () => {
      this.initCardStyle()
    }
    await this.init()
    this.loopRefreshWidget()
    if (!this.isPreview) {
      this._getNavStyle()
    }
  },
  computed: {
    scrollTop () {
      let _scrollTop = this.shortcutNav.length
      _scrollTop = []
      const navTitle = this.$el.querySelectorAll('.nav-title')
      for (let i = 0; i < this.totalNav.length; i++) {
        _scrollTop.push(navTitle[i].offsetTop)
      }
      return _scrollTop
    }
  },
  data () {
    return {
      noData: false,
      returnTopFlag: false,
      shortcutNav: [], // 快捷菜单
      tempShortcutNav: [], // 临时快捷菜单数据
      totalNav: {}, // 所有菜单
      cardNavs: [],
      navNum: 0,
      shortcutDialog: false, // 快捷导航flag
      navCheckList: [], // 快捷导航选中集合
      currentChenklist: [], // 当前快捷导航选中集合
      // scrollTop: [], // 各级菜单的滚动值存储
      scrollTimer: null, // 滚动定时器
      checkboxDisabled: false,
      wrapClass: 'el-nav-scrollbar__wrap',
      flag: false, // 用于标志锚点导航
      navStyle: false // 用于卡片切换
    }
  },
  watch: {
    shortcutDialog (val) {
      if (val) {
        this.wrapClass = 'el-nav-scrollbar__wrap hidden'
      } else {
        this.wrapClass = 'el-nav-scrollbar__wrap'
      }
    },
    navStyle (val) {
      if (!this.isPreview) {
        if (!val) {
          api.homepage.changeNavStyle({ style: 'list' })
        } else {
          api.homepage.changeNavStyle({ style: 'card' })
          this.$nextTick(() => {
            this.initCardStyle()
          })
        }
      }
    },
    shortcutNav () {
      // this.setScrollTop()
    }
  },
  methods: {
    defaultPic (e) {
      e.target.src = defaultPic
    },
    _getNavStyle () {
      api.homepage.getNavStyle().then(res => {
        this.navStyle = res.data === 'card'
      })
    },
    // 轮巡请求
    loopRefreshWidget () {
      if (this.refreshPeriod !== 0) {
        setInterval(() => {
          this.init()
        }, this.refreshPeriod * 1000)
      }
    },
    // 初始化
    async init () {
      await this._getMenu()
      this.addEvent()
      let listCt = this.$refs.listCt
      this.$nextTick(() => {
        let h = listCt && listCt.offsetHeight === 0 ? 600 : listCt.offsetHeight
        this.$refs.slideBox.style.height = h + 'px'
      })
    },
    // 卡片模式
    initCardStyle () {
      if (this.cardNavs.length > 0) {
        let appBoxs = document.getElementsByClassName('app-box')
        let w = 0
        for (let i = 0; i < appBoxs.length; i++) {
          w = Math.max(appBoxs[i].offsetWidth, w)
        }
        let card = document.getElementById('listNavCards').getElementsByClassName('card')
        let appName = document.getElementsByClassName('app-name')
        // let appIntro = document.getElementsByClassName('app-intro')
        let ctBox = document.getElementsByClassName('box')
        for (let i = 0; i < card.length; i++) {
          card[i].style.height = (w - 16) / 1.5 + 'px'
          appName[i].style.width = w * 0.8 + 'px'
          // appIntro[i].style.width = w * 0.8 + 'px'
          if (ctBox[i].offsetHeight > 40) {
            this.cardNavs[i]['isOver'] = true
            let temp = this.cardNavs[i]
            this.$set(this.cardNavs, i, temp)
          } else {
            this.cardNavs[i]['isOver'] = false
            let temp = this.cardNavs[i]
            this.$set(this.cardNavs, i, temp)
          }
        }
      }
    },
    // 添加事件
    addEvent () {
      // 保证缩放浏览器尺寸时，实时更新导航定位值
      // window.addEventListener('resize', this.setScrollTop)
    },
    // 获取首页菜单
    _getMenu () {
      let loadingInstance = Loading.service({ fullscreen: true })
      api.homepage
        .menuList()
        .then(data => {
          loadingInstance.close()
          this.noData = false
          this.totalNav = []
          this.cardNavs = []
          this.totalNav = data.data.filter(item => {
            if (item.index === true) {
              return false
            } else if (item.isShow === 1) {
              return false
            } else if (item.quick === true) {
              this.shortcutNav = item.children || []
              this.tempShortcutNav = item.children || []
              return false
            } else if (!item.children || item.children.length === 0) {
              return false
            }
            return true
          })

          this.totalNav.forEach(item => {
            item._path = `/${item.menuId}`
            item.desc = item.desc || ''
            item['isOver'] = false
            if (item.children && item.children.length !== 0) {
              item.children.forEach(child => {
                child._path = `/${child.parentId}/${child.menuId}`
                child.desc = child.desc || ''
                child['isOver'] = false
                this.cardNavs.push(child)
              })
            }
          })
          this.shortcutNav.forEach(child => {
            child._path = `/${child.parentId}/${child.menuId}`
          })
          // 当菜单数量小于8个时，自动切换为卡片模式
          this.navStyle = this.cardNavs.length < 8
        })
        .catch(() => {
          loadingInstance.close()
          this.noData = true
        }).then(() => {
          this.$nextTick(() => {
            this.initCardStyle()
          })
        })
    },
    /**
     * 侧边栏描点定位方法事件
     */
    // 点击侧边栏导航
    sidebarClick (index) {
      // 锚点导航标识量
      this.flag = true
      // 定义是否显示返回顶部按钮
      this.returnTopFlag = true
      // 定义定时器变量
      this.scrollTimer = null
      // 获取锚点所在位置
      let _index = (index > (this.scrollTop.length - 1)) ? (this.scrollTop.length - 1) : index
      let targetScroll = this.scrollTop[_index] - 28
      this.$refs.listNav.setScroll(targetScroll)
      this.navNum = index
      setTimeout(() => {
        this.flag = false
      }, 500)
    },
    // 滚动事件
    navScroll (scroll) {
      const containerScrollTop = scroll.scrollTop
      this.returnTopFlag = containerScrollTop >= 5
      this.$nextTick(() => {
        if (!this.flag) {
          let tempSort = []
          for (let i = 0; i < this.scrollTop.length; i++) {
            tempSort.push({
              val: Math.abs(this.scrollTop[i] - containerScrollTop),
              index: i
            })
          }
          tempSort = this.$lodash.sortBy(tempSort, ['val'])
          this.navNum = tempSort[0].index
        }
      })
    },
    /**
     * 编辑快捷导航相关事件
     */
    // 添加快捷导航事件
    addShortcutNav () {
      this.tempShortcutNav = JSON.parse(JSON.stringify(this.shortcutNav))
      this.navCheckList = []
      this.shortcutNav.forEach(item => {
        this.navCheckList.push(item.menuId)
      })
      this.currentChenklist = JSON.parse(JSON.stringify(this.navCheckList))
      this.shortcutDialog = true
      this.checkboxDisabled = this.navCheckList.length >= 10
    },
    // 保存快捷导航
    saveShortcutNav () {
      let menuIds = []
      this.tempShortcutNav.forEach(item => {
        menuIds.push(item.menuId)
      })
      api.homepage
        .add({ menuIds: menuIds.join(',') })
        .then(data => {
          this.shortcutNav = JSON.parse(JSON.stringify(this.tempShortcutNav))
          this.$message.success(
            this.$t('components.widgetHomepage.nav.edit_menu_suc')
          )
          // 导航菜单位置发生变化
          // this.setScrollTop()
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
      this.shortcutDialog = false
    },
    // 取消快捷导航
    cannelShortcutNav () {
      this.shortcutDialog = false
    },
    // 复选框变化事件
    navCheckChange (checks) {
      if (checks.length === this.currentChenklist.length) {
        return
      }
      // 最多不能超过10个
      this.checkboxDisabled = checks.length >= 10
      // 判断是增加还是减少
      let checkFlag = checks.length > this.currentChenklist.length
      let changeItem = this.$lodash.xor(checks, this.currentChenklist)
      if (checkFlag) {
        this.totalNav.forEach(item => {
          item.children.forEach(child => {
            // child.menuId需要转变为字符串
            if (child.menuId.toString() === changeItem[0]) {
              this.tempShortcutNav.push(child)
            }
          })
        })
      } else {
        this.tempShortcutNav = this.tempShortcutNav.filter(item => {
          return item.menuId !== changeItem[0]
        })
      }
      this.currentChenklist = JSON.parse(JSON.stringify(checks))
    },
    // 删除快捷菜单
    removeShortcutNav (menuId) {
      api.homepage
        .delete({ shortcutIds: menuId })
        .then(() => {
          this.$message.success(
            this.$t('components.widgetHomepage.nav.remove_menu_suc')
          )
          this.shortcutNav = this.shortcutNav.filter(item => {
            return menuId !== item.menuId
          })
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    },
    // 弹框中去除选中的快捷菜单
    deleteTempShortcut (id) {
      this.tempShortcutNav = this.tempShortcutNav.filter(item => {
        return item.menuId !== id
      })
      this.navCheckList = this.navCheckList.filter(item => {
        return item !== id
      })
      this.currentChenklist = this.currentChenklist.filter(item => {
        return item !== id
      })
      this.checkboxDisabled = this.navCheckList.length >= 10
    },
    // 菜单点击
    navCardClick (menu) {
      if (menu.openType === 2) {
        window.open(menu.fullUrl)
      } else {
        this.openMenu({
          value: menu.menuId,
          key: 'menuId'
        })
      }
    },
    // 返回顶部
    returnTop () {
      document.querySelector('.el-nav-scrollbar__wrap').scrollTop = 0
      this.navNum = 0
    },
    // vuex
    ...mapActions(['openMenu'])
  },
  components: {
    draggable,
    noData
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/var.less";
@import "~assets/styles/mixin.less";
.list-nav-page {
  width: 100%;
  height: 100%;
  background-image: url("../../../assets/images/isee_home_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  .list-content {
    position: relative;
    width: 100%;
    height: 100%;
    .return-up {
      position: absolute;
      bottom: 32px;
      right: 32px;
      box-sizing: border-box;
      width: 40px;
      height: 40px;
      font-size: 14px;
      color: #3c3c3c;
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2), 0 2px 12px 0 rgba(0, 0, 0, 0.12);
      background: #fff;
      cursor: pointer;
      padding: 13px;
      z-index: 1;
    }
    .list-nav {
      position: relative;
      width: 100%;
      height: 100%;
      box-sizing: border-box;

      .m-switch-box {
        position: absolute;
        right: 32px;
        top: 12px;
        box-sizing: border-box;
      }
      .m-main-ctn {
        width: 100%;
        height: 100%;
        max-width: 1200px;
        margin: 0 auto;
        padding-bottom: 16px;
        .m-list-ctn {
          float: left;
          width: calc(~"100% - 150px");
          padding-bottom: 16px;
          .menu-list {
            width: 100%;
            box-sizing: border-box;
            padding: 28px 0 0 40px;
            &.mt-12 {
              margin-top: 12px;
            }
            .nav-title {
              height: 16px;
              line-height: 16px;
              font-size: @font-size-title;
              color: rgba(0, 0, 0, 0.9);
              position: relative;
              font-weight: bold;
              &.active {
                &:after {
                  position: absolute;
                  top: -2px;
                  left: -6px;
                  content: "";
                  width: 2px;
                  height: 20px;
                  background-size: contain;
                  border-radius: 0;
                }
              }
            }
            .nav-tips {
              max-height: 12px;
              line-height: 12px;
              margin-top: 10px;
              font-size: @font-size;
              color: rgba(0, 0, 0, 0.4);
            }
            .content {
              .content-empty {
                margin-top: 14px;
                height: 134px;
                width: 134px;
                cursor: pointer;
                background: url("../../../assets/images/card_menu_add_big.png")
                  no-repeat center;
                background-size: contain;
              }
              .content-item {
                position: relative;
                margin-top: 14px;
                height: 134px;
                width: 134px;
                text-align: center;
                padding-top: 26px;
                cursor: pointer;
                border-radius: 2px;
                opacity: 0.95;
                background: hsla(0, 0%, 100%, 0.4);
                box-shadow: 0 1px 1px #ccc;
                margin: 16px 16px 16px 0;
                transition: 0.3s;
                .remove {
                  position: absolute;
                  right: 4px;
                  top: 4px;
                  display: none;
                }
                &:hover {
                  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
                  background: #fff;
                  .remove {
                    display: block;
                  }
                }
                .image {
                  display: block;
                  width: 64px;
                  height: 64px;
                  margin-left: 23px;
                  margin-bottom: 8px;
                }
                .sub-nav-title {
                  display: inline-block;
                  width: calc(~"100% - 16px");
                  padding: 0 8px;
                  font-size: @font-size;
                  color: @font-color;
                  height: 20px;
                  line-height: 20px;
                  .text-over();
                }
              }
            }
          }
        }
        .m-slide-pos {
          width: 150px;
          float: left;
          .nav-list {
            position: fixed;
            display: table;
            vertical-align: middle;
            .m-main-slide {
              display: table-cell;
              vertical-align: middle;
              .nav-item {
                display: block;
                position: relative;
                text-decoration: none;
                font-size: 12px;
                cursor: pointer;
                height: 40px;
                line-height: 40px;
                padding: 0 0 0 30px;
                overflow: hidden;
                &:after {
                  position: absolute;
                  top: 0;
                  left: 14px;
                  content: "";
                  width: 1px;
                  height: 40px;
                  background: rgba(0, 0, 0, 0.12);
                }
                &.active {
                  font-size: 16px;
                  &:after {
                    position: absolute;
                    top: 0;
                    left: 14px;
                    content: "";
                    width: 2px;
                    height: 40px;
                    background-size: contain;
                    border-radius: 0;
                  }
                }
                &:hover {
                  font-size: 16px;
                  color: @font-color;
                }
              }
            }
          }
        }
      }
      .m-main-ctn-card {
        width: 70%;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 48px 0;
        list-style: none;
        .app-box {
          width: 25%;
          min-width: 228px;
          min-height: 153px;
          display: block;
          float: left;
          padding: 0;
          margin: 0 0 16px 0;
          .card {
            margin: 0 8px;
            background: #fff;
            border: 1px solid rgba(0, 0, 0, 0.12);
            border-radius: 2px;
            cursor: pointer;
            .card-outer {
              display: table;
              width: 100%;
              height: 100%;
              table-layout: fixed;
              .card-inner {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                .app-icon {
                  width: 64px;
                  height: 64px;
                }
                .app-name {
                  font-size: 16px;
                  font-weight: 700;
                  height: 22px;
                  line-height: 22px;
                  width: 100%;
                  box-sizing: border;
                  margin: 0 auto;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  color: #4a4a4a;
                }
                .f-toe {
                  overflow: hidden;
                  word-wrap: normal;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                .app-intro {
                  width: calc(~"100% - 32px");
                  height: 40px;
                  margin: 5px auto;
                  font-size: 12px;
                  line-height: 20px;
                  overflow: hidden;
                  .box {
                    position: relative;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    .cont {
                      color: #999;
                    }
                    .u-omit {
                      position: absolute;
                      top: 18px;
                      right: -1px;
                      width: 14px;
                      height: 20px;
                      background: #fff;
                    }
                  }
                }
              }
            }
            &:hover {
              background: rgba(0, 0, 0, 0.04);
              border: 1px solid rgba(0, 0, 0, 0.04);
              .u-omit {
                background: #ebebeb !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
@import "~assets/styles/var.less";
@import "~assets/styles/mixin.less";
/*弹框样式*/
.shortcut-nav {
  box-sizing: border-box;
  padding: 25px 24px 0 24px;
  .shortcut-nav-list {
    padding: 0 0 8px 0;
    .shortcut-nav-item {
      height: 30px;
      margin: 0 8px 8px 0;
      line-height: 30px;
      padding: 0 40px 0 15px;
      font-size: @font-size-b;
      color: @font-color-6;
      background-color: @bg;
      border: 1px solid @border-color3;
      border-radius: 2px;
      cursor: move;
      position: relative;
      .shortcut-nav-item-remove {
        cursor: pointer;
        position: absolute;
        font-size: 8px;
        top: 9px;
        right: 11px;
      }
    }
  }
  .shortcut-total-nav-list {
    .shortcut-total-nav-item {
      .total-nav-item-title {
        font-size: @font-size;
        color: @font-color-l;
        line-height: 20px;
        margin: 0 0 8px 0;
      }
      .nav-checkbox {
        margin: 0 36px 15px 0;
        color: @font-color-5;
      }
    }
  }
}
.shortcut-dialog-title {
  width: 700px;
  float: left;
  height: 40px;
  padding-left: 16px;
  .title-strong {
    font-size: @font-size-title;
    font-weight: bold;
    color: @font-color-5;
  }
  .title-light {
    font-size: @font-size;
    color: @font-color-l;
  }
}
</style>
